// Import required libraies
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { Box, Checkbox, Paper } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ClearIcon from "@mui/icons-material/Clear";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Grid from "@mui/material/Grid";

// * Import data
import { useTheme } from "@emotion/react";

// * Import 3rd party
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { LightTooltip } from "../../../../kit/LightToolTip";
import { fetchOwnersData, fetchOwnersData2 } from "../../../../services/api";
import InfoToolTip from "../../../../components/MUIComponents/InfoToolTip";
import CloseIcon from "@mui/icons-material/Close";
import { MultiSelectChipCard } from "../../../../kit/MultiselectChipCard";

const numberOfChips = (moreChipsFlag) => {
  const width = window.innerWidth;
  if (moreChipsFlag) {
    return 5;
  }
  if (width < 1100) {
    return 1;
  } else if (width < 1273) {
    return 2;
  } else if (width >= 1273 && width < 1565) {
    return 2;
  } else {
    return 3;
  }
};

const StyledAutoComplete = styled(
  Autocomplete,
  {}
)(({ theme, customProps }) => ({
  // height: "2em !important",
  // width: "100%",
  // borderRadius: theme.size[4],
  "& .MuiFilledInput-root-notchedOutline": {
    borderColor: "transparent !important",
  },
  "& .MuiFilledInput-root": {
    height: theme.size[50],
    backgroundColor: theme.palette.form.fieldBackground,
    paddingTop: "0px",
    fontSize: theme.size[13],
    color: theme.palette.form.text,
    borderBottom: "0px !important",
    "&:before, &:after": {
      borderBottom: "0px !important",
    },
  },
  "& .Mui-disabled": {
    backgroundColor: `${theme.palette.rapidInfra.disabledGrey2} !important`,
  },
}));

// # COMPONENT
const OktaUserMultiSelect = ({
  label,
  componentUsed = "default",
  type,
  value,
  placeholder,
  prefix,
  options,
  info,
  isRequired = false,
  isDisabled = false,
  componentId,
  categoryId,
  isOktaUserEnabled = false,
  loggedInUserEmail,
  disableInputSelection = false,
  onChange = () => {},
}) => {
  const theme = useTheme();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [ownersFilteredOptions, setOwnersFilteredOptions] = useState([
    ...options,
  ]);

  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const getOktaSearchUsersFn = async (searchTerm) => {
    try {
      const response = await fetchOwnersData2({
        payload: { search_string: searchTerm },
      });

      // Include the logged-in user in the dropdown as well
      let data = response.data?.data || [];

      let newOptions = data.map((item) => {
        return {
          name: item.name,
          user_id: item.email,
        };
      });

      setOwnersFilteredOptions(newOptions);
    } catch (error) {
      console.log("error", error?.error);
    }
    setIsLoading(false);
  };

  const ChipCard = ({ chipValue, theme }) => {
    return (
      <Grid item>
        <Box
          sx={{
            backgroundColor: theme.palette.rapid.lightGrey,
            color: theme.palette.rapidInfra.text,
            fontSize: theme.size[12],
            fontWeight: theme.fontWeight[500],
            padding: theme.size[8],
            borderRadius: theme.size[4],
            marginRight: theme.size[8],
          }}
        >
          {chipValue}
          {componentUsed == "Details" && !isDisabled ? (
            <CloseIcon
              sx={{
                fontSize: theme.size[16],
                cursor: "pointer",
                color: theme.palette.rapidInfra.text,
                marginTop: "-5px",
                marginRight: "-5px",
                marginLeft: theme.size[4],
                color: "red",
              }}
              onClick={() => {
                const newValue = value.filter(
                  (item) => item.user_id !== chipValue
                );
                onChange(categoryId, componentId, newValue);
              }}
            />
          ) : null}
        </Box>
      </Grid>
    );
  };

  useEffect(() => {
    let timeoutId = null;
    if (isOktaUserEnabled) {
      if (!isLoading) {
        setIsLoading(true);
      }
      setOwnersFilteredOptions([]);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => getOktaSearchUsersFn(searchTerm), 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Default-select the logged-in user when Access List and value is empty
  useEffect(() => {
    if (label === "Access List" && loggedInUserEmail && (!value || value.length === 0)) {
      onChange(categoryId, componentId, [{ name: loggedInUserEmail.split("@")[0], user_id: loggedInUserEmail }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // # JSX
  return (
    <>
      {prefix !== "" && (
        <span
          style={{
            fontSize: theme.size[12],
            fontWeight: theme.fontWeight[500],
            marginRight: theme.size[8],
            color: theme.palette.rapidInfra.text,
          }}
        >
          {prefix}
        </span>
      )}
      <div
        style={{
          fontSize:
            componentUsed === "Details" ? theme.size[13] : theme.size[12],
          fontWeight: theme.fontWeight[500],
          color: theme.palette.rapidInfra.text,
          marginBottom: theme.size[8],
        }}
      >
        {label}

        {isRequired && <span style={{ color: "red", marginLeft: 5 }}>*</span>}
        {info && componentUsed === "Details" ? (
          <InfoToolTip theme={theme} title={info} />
        ) : (
          <LightTooltip
            title={info}
            placement="top-end"
            arrow
            sx={{
              "& .MuiTooltip-tooltip": {
                padding: "8px 12px", // Adjust padding if needed
              },
            }}
          >
            <InfoOutlinedIcon
              style={{
                fontSize: theme.size[14],
                color: theme.palette.rapidInfra.infoIcon,
                marginLeft: 5,
                cursor: "pointer",
              }}
            />
          </LightTooltip>
        )}
      </div>

      {disableInputSelection ? (
        <Grid container spacing={1}>
          {label === "Approvers List"
            ? options?.map((option, index) => {
                return (
                  <ChipCard
                    key={index}
                    chipValue={option.user_id}
                    theme={theme}
                  />
                );
              })
            : componentUsed === "Details"
            ? value?.map((option, index) => {
                return (
                  <MultiSelectChipCard
                    key={index}
                    chipValue={option.user_id}
                    theme={theme}
                    isDisabled={isDisabled}
                    value={value || []}
                    handleChange={(chipValue, value) => {
                      const newValue = value.filter(
                        (item) => item.user_id !== chipValue
                      );
                      onChange(categoryId, componentId, newValue);
                    }}
                  />
                );
              })
            : value?.map((option, index) => {
                return (
                  <ChipCard
                    key={index}
                    chipValue={option.user_id}
                    theme={theme}
                  />
                );
              })}
        </Grid>
      ) : (
        <StyledAutoComplete
          multiple
          id="tags-filled"
          options={ownersFilteredOptions}
          value={value}
          inputValue={searchTerm}
          disabled={isDisabled}
          freeSolo={false}
          disableCloseOnSelect
          renderTags={(value, getTagProps) => {
            const numberOfChip = 3;
            return componentUsed === "Details" ? (
              <></>
            ) : (
              <>
                {value.slice(0, numberOfChip).map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option.user_id}
                    title={option.user_id}
                    deleteIcon={
                      <ClearIcon
                        sx={{
                          color: `${theme.palette.form.text} !important`,
                          fontSize: `${theme.size[15]} !important`,
                        }}
                      />
                    }
                    {...getTagProps({ index })}
                    style={{
                      color: theme.palette.form.text,
                      borderRadius: theme.size[4],
                      borderColor: theme.palette.secondary.main,
                      maxWidth: theme.size[120],
                      width: value.length > 1 ? theme.size[70] : "auto",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: theme.size[0],
                      height: theme.size[25],
                    }}
                  />
                ))}
                {value.length > numberOfChip &&
                  `+${value.length - numberOfChip} more`}
              </>
            );
          }}
          PaperComponent={({ children }) => (
            <Paper
              style={{ backgroundColor: theme.palette.form.fieldBackground }}
            >
              {children}
            </Paper>
          )}
          renderOption={(props, option, { selected }) => {
            const flag = value.some((elem) => elem.user_id === option.user_id);
            return (
              <li
                {...props}
                style={{
                  color: theme.palette.form.text,
                  fontSize: theme.size[13],
                  height: theme.size[40],
                }}
              >
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{
                    marginRight: 8,
                    color: theme.palette.secondary.main,
                  }}
                  checked={flag}
                />
                {option.user_id}
              </li>
            );
          }}
          filterOptions={(options, params) => {
            const filtered = options.filter((option) =>
              option.user_id
                .toLowerCase()
                .includes(params.inputValue.toLowerCase())
            );
            return filtered;
          }}
          getOptionLabel={(option) => option.name}
          PopperProps={{
            disablePortal: true,
          }}
          popupIcon={<KeyboardArrowDownIcon />}
          sx={{
            "& .MuiAutocomplete-popupIndicator": {
              color: theme.palette.icons.main,
              opacity: 0.5,
            },
            "&:hover": {
              backgroundColor: "transparent !important",
            },
          }}
          disableClearable
          onChange={(e, value) => {
            onChange(categoryId, componentId, value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              placeholder={placeholder}
              margin="normal"
              fullWidth
              sx={{
                marginTop: 0,
                marginBottom: 0,
                height: "2em !important",
              }}
            />
          )}
          loading={isLoading}
          loadingText={
            <div
              style={{
                color: theme.palette.form.text,
                fontSize: theme.size[13],
              }}
            >
              Loading...
            </div>
          }
          noOptionsText={
            <div
              style={{
                color: theme.palette.form.text,
                fontSize: theme.size[13],
              }}
            >
              {isOktaUserEnabled ? "No User Found" : "No Option Found"}
            </div>
          }
          onInputChange={(e, val, reason) => {
            if (reason === "input") {
              setSearchTerm(val);
            } else if (reason === "clear") {
              setSearchTerm("");
            }
          }}
          onClose={() => {
            setSearchTerm(""); // Clear search text on dropdown close
          }}
        />
      )}
      {!disableInputSelection && (
        <Grid container spacing={1}>
          {componentUsed === "Details" &&
            value?.map((option, index) => {
              return (
                <MultiSelectChipCard
                  key={index}
                  chipValue={option.user_id}
                  theme={theme}
                  isDisabled={isDisabled}
                  value={value}
                  handleChange={(chipValue, value) => {
                    const newValue = value.filter(
                      (item) => item.user_id !== chipValue
                    );
                    onChange(categoryId, componentId, newValue);
                  }}
                />
              );
            })}
        </Grid>
      )}
    </>
  );
};

// # EXPORTS
export default OktaUserMultiSelect;
